export const administrationAccountsHeadOfficeDetails = {
    template: require('./administration-accounts-head-office-details.html'),
    controller: 'AdministrationAccountsHeadOfficeDetailsController'
};
